// Widget Scripts
import cardWidget from './js/widgets/cardWidget.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidgetVideo from './js/widgets/cardWidgetVideo.js';
import seoWidget from './js/widgets/seoWidget.js';
import seoImageWidget from './js/widgets/seoImageWidget.js';
import cardWidgetEmail from './js/widgets/cardWidgetEmail.js';
import footerSeo from './js/widgets/footerSeo.js';

// Custom Theme Scripts
import './js/localjs.js';

$(document).ready(function () {
  // footerLogo();
});

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    if ($('body').hasClass('eventsMode')) {
      $(window).on('load', function () {
        cardWidgetVideo(); // swiper is default, but based on event mode, Vimeo video widgetwill be render
        $('#swiperWidget:empty').remove();
      });
    } else {
      swiperWidget(); // rendering the default widget
    }
    cardWidget();
    seoWidget();
    seoImageWidget();
    cardWidgetEmail();
    footerSeo();
  });
}
